import { AutoComplete } from "ant-design-vue";
const { ...other } = AutoComplete;
const YwAutoComplete = {
  ...other,
  name: "YwAutoComplete",
};

YwAutoComplete.install = function (Vue) {
  Vue.component(YwAutoComplete.name, AutoComplete);
};

export default YwAutoComplete;